import {
  DOWNLOAD_ALLOCATION_FILE_FAILURE,
  DOWNLOAD_ALLOCATION_FILE_REQUEST,
  DOWNLOAD_ALLOCATION_FILE_SUCCESS,
  DOWNLOAD_ALLOCATION_UPLOAD_TEMPLATE,
  DOWNLOAD_ALLOCATION_UPLOAD_TEMPLATE_FAILURE,
  DOWNLOAD_ALLOCATION_UPLOAD_TEMPLATE_SUCCESS,
  GET_ALLOCATION_HISTORY_FAILURE,
  GET_ALLOCATION_HISTORY_REQUEST,
  GET_ALLOCATION_HISTORY_SUCCESS,
  UPLOAD_PROPOSAL_FAILURE,
  UPLOAD_PROPOSAL_REQUEST,
  UPLOAD_PROPOSAL_SUCCESS,
} from "./actionTypes";

export const getAllocationHistoryRequest = (payload: {
  page: number;
  size: number;
}) => ({
  type: GET_ALLOCATION_HISTORY_REQUEST,
  payload,
});

export const getAllocationHistorySuccess = (payload: any) => ({
  type: GET_ALLOCATION_HISTORY_SUCCESS,
  payload,
});

export const getAllocationHistoryFailure = (payload: any) => ({
  type: GET_ALLOCATION_HISTORY_FAILURE,
  payload,
});

export const downloadAllocationFileRequest = (payload: {
  uniqueCode: number | string;
}) => ({
  type: DOWNLOAD_ALLOCATION_FILE_REQUEST,
  payload,
});

export const downloadAllocationFileSuccess = (payload: any) => ({
  type: DOWNLOAD_ALLOCATION_FILE_SUCCESS,
  payload,
});

export const downloadAllocationFileFailure = (payload: any) => ({
  type: DOWNLOAD_ALLOCATION_FILE_FAILURE,
  payload,
});

export const uploadProposalRequest = (payload: any) => ({
  type: UPLOAD_PROPOSAL_REQUEST,
  payload,
});

export const uploadProposalSuccess = (payload: any) => ({
  type: UPLOAD_PROPOSAL_SUCCESS,
  payload,
});

export const uploadProposalFailure = (payload: any) => ({
  type: UPLOAD_PROPOSAL_FAILURE,
  payload,
});

export const downloadAllocationUploadTemplate = () => ({
  type: DOWNLOAD_ALLOCATION_UPLOAD_TEMPLATE,
});

export const downloadAllocationUploadTemplateSuccess = (payload: any) => ({
  type: DOWNLOAD_ALLOCATION_UPLOAD_TEMPLATE_SUCCESS,
  payload,
});

export const downloadAllocationUploadTemplateFailure = (payload: any) => ({
  type: DOWNLOAD_ALLOCATION_UPLOAD_TEMPLATE_FAILURE,
  payload,
});
